import { useEffect, useRef } from 'react';

import { useGoldDateParticipation } from '../../hooks/useGoldDateParticipation';
import InfoContent from '../InfoContent';

import DesktopContent from './DesktopContent';
import MobileContent from './MobileContent';

import { Modal } from '@/components';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import useToast from '@/hooks/useToast';
import useTourney from '@/hooks/useTourney';
import { ResponseInfoFeoroUsuario } from '@/types/goldDate';

interface MainContentProps {
  dataInitUsuarioOro?: ResponseInfoFeoroUsuario;
  refetch: () => void;
}

const MainContent = ({ dataInitUsuarioOro, refetch }: MainContentProps) => {
  const { isMobile, isDesktop } = useIsDesktop();
  const { tourneyModal, successModal, handleTourneyModal, onCardButtonClick } =
    useGoldDateParticipation({ dataInitUsuarioOro });
  const { tourneyData, updateTourney } = useTourney();

  const toast = useToast();
  const toastShowed = useRef<boolean>(false);

  useEffect(() => {
    if (
      dataInitUsuarioOro?.pinSugerido &&
      !toastShowed.current &&
      !dataInitUsuarioOro.participaActual
    ) {
      toast.show(
        'Ya conseguiste tu Pin Especial para la Fecha de Oro. Ahora ingresalo haciendo clic en el botón PARTICIPAR para competir en la Fecha.'
      );
      toastShowed.current = true;
    }
  }, [
    dataInitUsuarioOro?.participaActual,
    dataInitUsuarioOro?.pinSugerido,
    toast,
  ]);

  return (
    <>
      {isDesktop && (
        <DesktopContent
          dataInitUsuarioOro={dataInitUsuarioOro}
          onCardButtonClick={onCardButtonClick}
        />
      )}
      {isMobile && (
        <MobileContent
          dataInitUsuarioOro={dataInitUsuarioOro}
          onCardButtonClick={onCardButtonClick}
        />
      )}

      {/* MODAL INFO */}
      <Modal
        className="w-[600px] text-center px-[38px]"
        controlledOnClose={() => {
          updateTourney({ showModalInfo: false });
        }}
        disableBodyScroll={true}
        isControlledOpen={Boolean(tourneyData.showModalInfo)}
        render={() => <InfoContent />}
        size="sm"
        variant="controlled"
      />

      <Modal
        controlledOnClose={() => {
          handleTourneyModal({
            open: false,
          });
        }}
        disableBodyScroll={true}
        isControlledOpen={tourneyModal.open}
        render={() => tourneyModal.content}
        size="xs"
        title={tourneyModal.title}
        variant="controlled"
      />
      {/* segundo modal para cuanado se concreto todo con exito */}
      <Modal
        controlledOnClose={() => {
          handleTourneyModal({
            openSuccessModal: false,
          });
          refetch(); // Esto refrescará los datos
        }}
        disableBodyScroll={true}
        isControlledOpen={tourneyModal.openSuccessModal}
        render={() => successModal.content}
        size="xs"
        title={successModal.title}
        variant="controlled"
      />
    </>
  );
};

export default MainContent;
